/**
 * Пустой радар: что это за вкладка и куда идти за первой подпиской.
 *
 * Прежде здесь стояла короткая форма первой подписки — марка, регион,
 * цена — и создавала её прямо на месте. Решением владельца продукта
 * 19 сентября 2026 форма убрана.
 *
 * Довод простой: условий в поиске вдесятеро больше, и человек, заведший
 * подписку из трёх полей, получал не то, что искал, — а потом правил её
 * там же, в поиске. Две двери в одно место, причём узкая стояла первой.
 *
 * Осталось одно: сказать, что это за вкладка, и провести в поиск. Радар
 * без подписок выглядит сломанным, если не объяснить, что он пуст не по
 * ошибке.
 */

import type React from 'react';

export function OnboardingScreen({
  onSearch,
}: {
  /**
   * Переход в поиск.
   *
   * Необязателен по устройству вызывающего, но на деле передаётся
   * всегда. Без него остаётся текст без действия — и это честнее
   * кнопки, ведущей в никуда.
   */
  onSearch?: (() => void) | undefined;
}): React.JSX.Element {
  return (
    <div className="card onboarding">
      <p className="onboarding__lead">Это радар: сюда приходят машины по вашим подпискам.</p>

      <p className="subscribe__hint">
        Подписок пока нет. Соберите первую в поиске: там марка, модель, поколение, цена, пробег,
        регионы и ещё десяток условий — и сразу видно, сколько объявлений под них подходит.
      </p>

      {onSearch === undefined ? null : (
        <button type="button" className="button button--accent" onClick={onSearch}>
          Перейти в поиск
        </button>
      )}
    </div>
  );
}
